import React, { useCallback, useState } from 'react';
import Select, { components } from 'react-select';
import makeAnimated from 'react-select/animated';
import { Spinner } from 'react-bootstrap';

export default function SelectDropdown({
  optionsData,
  selectedValue,
  placeholder,
  label,
  id,
  handleSelect,
  rowData,
  className,
  isClearable = true,
  isMulti = false,
  closeMenuOnSelect = true,
  isDisabled = false,
  OptionLabel = 'label',
  OptionValue = 'value',
  addOptionLabel = [],
  handleSearch = false,
  handleClear,
  loadMoreOptions,
  isDataLoading = false
}) {
  const animatedComponents = makeAnimated();

  const handleInputChange = (inputValue, { action }) => {
    if (action === 'input-change' && handleSearch) {
      handleSearch(inputValue);
    }
  };

  const handleMenuClose = () => {
    // if (!selectedValue) {
    //   handleClear();
    // }
  };
  const customGetOptionLabel = (option) => {
    if (addOptionLabel.length <= 0) return `${option[OptionLabel]}`;
    else {
      let str = option[OptionLabel];
      for (let i in addOptionLabel) {
        str += ` - ${option[addOptionLabel[i]]}`;
      }
      return str;
    }
  };
  const DropdownIndicator = ({ children, ...props }) => {
    if (handleSearch) {
      return (
        <components.DropdownIndicator {...props}>
          {children}
          <span style={{ cursor: 'pointer', marginLeft: "5px" }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-search"
              viewBox="0 0 16 16"
            >
              <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
            </svg>
          </span>
        </components.DropdownIndicator>
      )
    } else {
      return (
        <components.DropdownIndicator {...props}>
          {children}
        </components.DropdownIndicator>
      )

    }
  };
  // const CustomControl = ({ children, ...props }) => (
  //   <components.Control {...props}>
  //     {isDataLoading &&
  //       <Spinner variant="primary" />}
  //     {children}
  //   </components.Control>
  // );


  return (
    <>
      <Select
        className={`machadalo-select-box`}
        label={label}
        id={id}
        placeholder={placeholder}
        options={optionsData}
        value={selectedValue}
        onChange={(e) => {
          handleSelect(e, rowData);
        }}
        isClearable={isClearable}
        isMulti={isMulti}
        isDisabled={isDisabled}
        getOptionLabel={customGetOptionLabel}
        getOptionValue={(option) => option[OptionValue]}
        onInputChange={handleInputChange}
        onMenuClose={handleMenuClose}
        closeMenuOnSelect={closeMenuOnSelect}
        components={{ ...animatedComponents, DropdownIndicator }}
        onMenuScrollToBottom={loadMoreOptions || null}
        styles={{
          control: (baseStyles, state) => ({
            ...baseStyles,
            borderColor: state.isFocused ? '' : '',
            width: '100% !important',
          }),
        }}
        theme={(theme) => ({
          ...theme,
          borderRadius: 0,
          colors: {
            ...theme.colors,
            primary25: 'rgb(178, 212, 255)',
            primary: '#3e59e3',
          },
        })}
      />
    </>
  );
}